<template>
	<v-dialog :value="true" persistent max-width="480">
		<v-card>
			<v-card-title class="headline">
				{{ $t('button.edit-interview') }}
			</v-card-title>

			<v-card-text>
				<div class="interview-summary mb-4">{{ interview.summary }}</div>

				<v-menu
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							:value="date"
							:label="$t('label.date')"
							prepend-icon="event"
							readonly
							outlined
							dense
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="date"
						no-title
						:locale="locale"
						first-day-of-week="1"
					></v-date-picker>
				</v-menu>

				<div class="d-flex" style="gap: 12px;">
					<v-menu
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:value="startTime"
								:label="$t('label.start-time')"
								prepend-icon="schedule"
								readonly
								outlined
								dense
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-time-picker
							v-model="startTime"
							format="24hr"
							:locale="locale"
						></v-time-picker>
					</v-menu>

					<v-menu
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:value="endTime"
								:label="$t('label.end-time')"
								prepend-icon="schedule"
								readonly
								outlined
								dense
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-time-picker
							v-model="endTime"
							format="24hr"
							:locale="locale"
						></v-time-picker>
					</v-menu>
				</div>

				<v-alert v-if="errorMessage" type="error" dense text class="mt-2">
					{{ errorMessage }}
				</v-alert>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text :disabled="isSaving" @click="onClose">
					{{ $t('button.cancel') }}
				</v-btn>
				<v-btn color="primary" :loading="isSaving" @click="handleSave">
					{{ $t('button.save') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import api from '@/api';

const INTERVIEW_TIMEZONE = 'Europe/Istanbul';

export default {
	name: 'EditInterviewDialog',
	props: {
		interview: {
			type: Object,
			required: true,
		},
		onClose: {
			type: Function,
			required: true,
		},
		onSuccess: {
			type: Function,
			required: true,
		},
	},
	data() {
		const start = new Date(this.interview.start_datetime);
		const end = new Date(this.interview.end_datetime);
		return {
			date: format(start, 'yyyy-MM-dd'),
			startTime: format(start, 'HH:mm'),
			endTime: format(end, 'HH:mm'),
			isSaving: false,
			errorMessage: '',
		};
	},
	computed: {
		...mapState({
			currentLang: state => state.currentUser.lang,
		}),
		locale() {
			return this.currentLang === 'tr' ? 'tr' : 'en';
		},
	},
	methods: {
		handleSave() {
			const startDate = new Date(`${this.date}T${this.startTime}:00`);
			const endDate = new Date(`${this.date}T${this.endTime}:00`);

			if (endDate <= startDate) {
				this.errorMessage = this.$t('text.end-time-must-be-after-start-time');
				return false;
			}

			this.errorMessage = '';
			this.isSaving = true;

			api.events
				.put({
					id: this.interview.id,
					start: {
						dateTime: startDate.toISOString(),
						timeZone: INTERVIEW_TIMEZONE,
					},
					end: {
						dateTime: endDate.toISOString(),
						timeZone: INTERVIEW_TIMEZONE,
					},
				})
				.then(() => {
					this.isSaving = false;
					this.onSuccess();
				})
				.catch(() => {
					this.isSaving = false;
					this.errorMessage = this.$t('text.interview-update-failed');
				});
		},
	},
};
</script>
